import { render, staticRenderFns } from "./DashboardLeft.vue?vue&type=template&id=03892c82&scoped=true&"
import script from "./DashboardLeft.vue?vue&type=script&lang=js&"
export * from "./DashboardLeft.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLeft.vue?vue&type=style&index=0&id=03892c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03892c82",
  null
  
)

export default component.exports